import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { OTP } from '../../core/models/otp-table';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable({ providedIn: 'root' })
export class OTPService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt']+'/otp/';
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  } 
    constructor(private http: HttpClient) { }
    public otps: OTP[] = [];
    public otps$ = new Subject<OTP[]>();
 
    createwithoutfile(userId:string,mobile:string,email:string) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();
        this.http.post(`${baseUrl}`, {userId,mobile,email}).subscribe(
          (response) => {
            resolve(response);

          },
          (error) => {
            reject(error);
          },
        );
      });
    }
    validateotp(otptoken: string) 
{
  return new Promise((resolve, reject) => {
    const baseUrl = this.getBaseUrl();
    this.http.post(`${baseUrl}validate/`, { otptoken }).subscribe(
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
}
    getotpss() {
      const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}`).subscribe(
          (otps: OTP[]) => {
            if (otps) {
              this.otps = otps;
              this.emitotpss();

            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    
      emitotpss() {
        this.otps$.next(this.otps);
      }
      getOTPreqById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error); 
            }
          );
        });
      }
      getotp(userId: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.post(`${baseUrl}`,{userId}).subscribe(
            (otps: OTP[]) => {
              if (otps) {
                this.otps = otps;
                this.emitotpss();
              }
            },
            (error) => {
              console.log(error);
            }
          );
        });
      }
      
   /* geexistenttotp(userId: string,annee:string,mois:string,source:string) 
    {
return new Promise((resolve, reject) => {
        this.http.post(API_URL_cloud+'/anneemois/',{userId,annee,mois,source}).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });

      }*/
      
    /*  create(otp: OTP) {
        return new Promise((resolve, reject) => {
          
          this.http.post(API_URL_cloud, otp).subscribe(
            (response) => {
              resolve(response);

            },
            (error) => {
              reject(error);
            },
          );
        });
      }*/
    
     
    
     /* modify(id: string, otpreq: OTP, image: File | string) {
        return new Promise((resolve, reject) => {
          let otpreqData: OTP | FormData;
          if (typeof image === 'string') {
            
            otpreqData = otpreq;
          } else {
            otpreqData = new FormData();
            otpreqData.append('otpreq', JSON.stringify(otpreq));
            otpreqData.append('image', image, otpreq.email);
          }
          this.http.put(API_URL_cloud + id, otpreqData).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }*/
      modifyotpreqById(id: string, otp: OTP) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.put(`${baseUrl}${id}`, otp).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        }); 
      }
     /* completeotpreqById(id: string, otp: OTP) {
        return new Promise((resolve, reject) => {
          
            
          
          this.http.put(API_URL_cloud+'modify/'+ id, otp).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }*/
    
      deleteotpById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }  
      deleteotpss() {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }
    }
